/*!
 * Created by netlogix GmbH & Co. KG
 *
 * @copyright netlogix GmbH & Co. KG
 */

import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Tour } from '@shared/models';

@Component({
    selector: 'app-confirmation-overlay',
    templateUrl: './confirmation-overlay.component.html',
    styleUrls: ['./confirmation-overlay.component.scss'],
    standalone: false
})
export class ConfirmationOverlayComponent {

  constructor(@Inject(MAT_DIALOG_DATA) public data: { tour: Tour }) {
  }
}
